import { WithHeightTransition } from "./WithHeightTransition";
import { WithSlider } from "./WithSlider";

export const HOC = {
  WithSlider,
  WithHeightTransition,
};
